const OVERLAY_LIFECYCLE_EVENTS = {
	PROJECT_PHASE_CHANGED: 'overlay_lifecycle_project_phase_changed',
	PAGE_PHASE_CHANGED: 'overlay_lifecycle_page_phase_changed',
	PHASE_CHANGED: 'overlay_lifecycle_phase_changed',
}

const OVERLAY_KINDS = {
	PROJECT: 'project',
	PAGE: 'page',
}

const OVERLAY_PHASES = {
	HIDDEN: 'hidden',
	LOADING: 'loading',
	OPENING: 'opening',
	VISIBLE: 'visible',
	CLOSING: 'closing',
	DESTROYING: 'destroying',
}

export { OVERLAY_LIFECYCLE_EVENTS, OVERLAY_KINDS, OVERLAY_PHASES }
